import './TextTemplate.scss';
import { IconArrowMedium } from '../icons/svgs';
import TextPreview from '../preview/TextPreview';
import NextAction from '../actions/NextAction';
class TextTemplate {
    structures() {
        return {
            title: {
                type: 'text',
                label: 'Title',
                placeholder: 'Slide Title',
            },
            description: {
                label: 'Description',
                type: 'tinymce',
                placeholder: 'Description max 600 characters',
                rules: {
                    maxChar: 600, // 320 characters
                }
            }
        }
    }

    type() {
        return 'TextTemplate';
    }

    name() {
        return 'Text';
    }
    iconType() {
        return this.structures().title.type;
    }
    canRearrange() {
        return true;
    }
    canRenameLabel() {
        return true;
    }
    imageTemplate() {
        return (
            <div>
                <img src={require('../assets/img/template-image-text.jpg')} className='img-fluid' alt='text template' />
            </div>
        );
    }
    textHighlight() {
        return (
            <div>
                <span className='font-weight-700 text-dark'>Text and Description</span>
                <span className='text-muted'> to help your storytelling better on the slide.</span>
            </div>
        );
    }
    getDuration() {
        return 60;
    }
    render(data, index, inEditor) {
        return (
            <TextPreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }

    actions(data, index) {
        return (
            <NextAction label='Next' icon={<IconArrowMedium />} />
        );
    }
}

export default TextTemplate;
